import { useCallback } from '@libs/use';

export default function useInjectScript(
  source: string,
  { isDisabled = false } = {}
) {
  const onLoaded = useCallback();

  return new Promise<void>(function (resolve, reject) {
    if (isDisabled) {
      return;
    }

    const head = document.head || document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.async = true;
    script.src = source;

    head.appendChild(script);

    script.onerror = (event) => {
      reject(
        new Error(
          `Failed to load ${typeof event === 'string' ? event : event.type}`
        )
      );
    };

    script.onload = () => {
      resolve();
      onLoaded.trigger();
    };
  });
}
